module.exports = __webpack_public_path__ + "img/thearmsdeal3collection.72bf558e.png";